import gql from 'graphql-tag';

export const queryForRolesAndBusinessUnits = gql`
  query queryForRolesAndBusinessUnits(
    $limit: Int
    $page: Int
    $query: RoleSortOrQuery
    $sort: RoleSortOrQuery
  ) {
    queryForRolesAndBusinessUnits(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        businessUnits
      }
      totalRecords
    }
  }
`;
